import { Status } from "./Status";

export class UpliftStatusSmartEnum {
    static Created = new Status("Created", 1, "pill--grey");
    static InProgress = new Status("In Progress", 2, "pill--blue");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "RecallStatusSmartEnum";
    }
}